import { User } from "snudbud-backbone-sdk";

interface ExitConfirmationModalProps {
  onConfirm: () => void;
  onCancel: () => void;
  profile?: User.FetchProfileReturn;
  conversationTurns: number;
  sessionTargetMessages: number;
}

export default function ExitConfirmationModal({
  onConfirm,
  onCancel,
  profile,
  conversationTurns,
  sessionTargetMessages,
}: ExitConfirmationModalProps) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4 shadow-xl animate-fade-in">
        <div className="text-center mb-4">
          <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-yellow-100 mb-4">
            <svg className="h-6 w-6 text-yellow-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </div>
          <h3 className="text-lg font-medium text-gray-900 mb-2">Are you sure you want to leave?</h3>

          {conversationTurns === 0 && (
            <p className="text-sm text-gray-500">
              You haven't exchanged any messages yet. Starting a conversation shows interest!
            </p>
          )}

          {conversationTurns > 0 && conversationTurns < sessionTargetMessages && (
            <p className="text-sm text-gray-500">
              You're making progress with {conversationTurns} out of {sessionTargetMessages} conversation turns.
              <span className="block mt-2 font-medium text-blue-600">
                Just {sessionTargetMessages - conversationTurns} more{" "}
                {sessionTargetMessages - conversationTurns === 1 ? "exchange" : "exchanges"} to reach your goal!
              </span>
            </p>
          )}

          {conversationTurns >= sessionTargetMessages && (
            <p className="text-sm text-gray-500">
              You have reached your conversation goal with {profile?.name || "this user"}.
              <span className="block mt-2 font-medium text-green-600">Feel free to continue or come back later!</span>
            </p>
          )}
        </div>
        <div className="flex justify-center space-x-3 mt-5">
          <button
            onClick={onCancel}
            className="px-4 py-2 bg-white text-gray-700 font-medium border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            Stay in chat
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 bg-blue-600 text-white font-medium rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            Leave chat
          </button>
        </div>
      </div>
    </div>
  );
}
